import record from "./record";

export default {
    graphql: {
        resourceBody: `
            ${record.graphql.resourceBody}
            activity_type
        `,
        updateVariables: (type) => `
            ${record.graphql.updateVariables(type)}
        `,
        updateQuery: (type) => `
            ${record.graphql.updateQuery(type)}
        `,
    },
};
